export const aboutData = {
    title: "Qui suis-je ?",
    description1: "Je m'appelle Espérance. Je suis web designer et développeuse.",
    description2: "Je suis passionnée par le développement et le design. Avec une licence en Analyse Informatique et Programmation, j’ai participé à des projets variés : plateformes web, applications mobiles, interfaces graphiques et prototypes. Mon approche allie technique et créativité, afin de proposer des solutions pratiques et agréables à utiliser.",
    image: 2
}